import { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { DivisionTiles } from '../components/DivisionTiles';
import { CTASection } from '../components/CTASection';
import { useReveal } from '../hooks/useReveal';
import { useI18n } from '../contexts/I18nContext';

export function Home() {
  const { language } = useI18n();
  useReveal(['home', language]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero />
      <DivisionTiles />
      <CTASection />
    </>
  );
}
